import React, { Component } from 'react';

// Dependencies
import Modal from 'react-modal';
import Router from 'next/router';
import Link from 'next/link';
import { inject, observer } from 'mobx-react';
import jwtDecode from 'jwt-decode';
import MobxReactForm from 'mobx-react-form';
import validatorjs from 'validatorjs';
import dvr from 'mobx-react-form/lib/validators/DVR';

import Input from './forms/parts/Input';
import ResetPassword from './ResetPassword';

// Static
const ErrorIcon = '/static/img/icon-error.svg';
const BlueCloseIcon = '/static/img/icon-close-blue.svg';

const plugins = { dvr: dvr(validatorjs) };

Modal.setAppElement('#__next');

const LoginForm = observer(({ form }) => (
  <form onSubmit={form.onSubmit}>
    <div className="form-group">
      <Input field={form.$('username')} />
    </div>
    <div className="form-group password-input">
      <Input field={form.$('password')} type="password" />
    </div>
    <button className="btn btn-pink" type="submit">
      Login
    </button>
  </form>
));

@inject('stores')
@observer
class Login extends Component {
  constructor(props) {
    super(props);

    // declaring fields
    const fields = [
      {
        name: 'username',
        label: 'Username',
        rules: 'required',
      },
      {
        name: 'password',
        label: 'Password',
        rules: 'required',
      },
    ];

    // declaring hooks
    const hooks = {
      onSuccess(form) {
        // sets stores error to empty string
        props.stores.alertStore.setError('');
        props.stores.userStore
          .login(form.values().username, form.values().password)
          .then((response) => {
            console.log(response);
            alert(response)
            if (response.token) {
              props.stores.cartStore.setCustomerId(
                jwtDecode(response.token).data.user,
              );

              Router.push('/dashboard');
            }
          })
          .catch((error) => {
            // gives stores error some string
            props.stores.alertStore.setError(error.data);
          });
      },
      onError() {
        // gives stores error some string
        props.stores.alertStore.setError('error');
      },
    };

    this.loginForm = new MobxReactForm({ fields }, { plugins, hooks });
  }

  openResetPassword = () => {
    this.props.stores.userStore.setResetPassword(true);
  };

  loginModalClose = () => {
    this.props.stores.userStore.setResetPassword(false);
    this.props.stores.alertStore.setError('');
    this.props.closeLoginModal();
  };

  render() {
    // variable that decides if eror is displayed
    const { error } = this.props.stores.alertStore;
    const { resetPassword } = this.props.stores.userStore;

    return (
      <div className="login-modal-wrapper">
        <Modal
          isOpen={this.props.open}
          onRequestClose={this.loginModalClose}
          contentLabel="Newsletter Modal"
          className="login-modal"
        >
          <div className={`login-fail ${error === '' ? 'hide' : ''}`}>
            <div className="login-fail-message">
              <div className="oops-container">
                <img src={ErrorIcon} alt="error" />
                <p className="error-message">
                  <strong>Oops!</strong>
                </p>
              </div>

              <p
                className="error-message"
                dangerouslySetInnerHTML={{ __html: error.message }}
              />
            </div>
          </div>
          <button type="button" onClick={this.loginModalClose}>
            <img
              src={BlueCloseIcon}
              className="modal-close-icon"
              alt="Close Modal"
            />
          </button>
          <div className="login-container">
            <h2 className={`login-title ${error !== '' ? 'hide' : ''}`}>
              {!resetPassword
                ? 'Hello There, Welcome back'
                : 'Forgot Your Password'}
            </h2>

            {!resetPassword ? (
              <div className="form-relative">
                <LoginForm form={this.loginForm} />
                {/* <button
                  className="link"
                  onClick={() => {
                    this.openResetPassword();
                    this.props.stores.alertStore.setError('');
                  }}
                >
                  forgot your password?
                </button> */}
              </div>
            ) : (
              <ResetPassword />
            )}
            <div className="login-footer">
              <p>Don't have an account yet? </p>
              <Link href="/products?category=237">
                <a className="link">Get a membership</a>
              </Link>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default Login;
